import React from "react";
import { FacebookProvider, CustomChat } from "react-facebook";

const FacebookMsg = () => {
  return (
    <FacebookProvider appId="1307473273496445" chatSupport>
      <CustomChat pageId="101206256016401" minimized={true} />
    </FacebookProvider>
  );
};

export default FacebookMsg;
